import Link from "next/link";
import styles from './PostalEntry.module.css';

const PostalEntry = () => {
    return (
        <Link href={'/alternative-entry-method'}>
          <a className={styles.postalEntryContainer}>
            Or... enter by post
          </a>
        </Link>
    );
}

export default PostalEntry;